// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 102 ? "xlsx" : chunkId) + "." + {"102":"1f69dc51","453":"7de70226"}[chunkId] + ".chunk.js";
};